var SvgPanZoom = require("./svg-pan-zoom.js");

module.exports = SvgPanZoom;



/*****************
 ** WEBPACK FOOTER
 ** ./~/svg-pan-zoom/src/browserify.js
 ** module id = 551
 ** module chunks = 2
 **/